import {
	SET_NEW_REPORT_DRAWER_STATE,
	SET_NEW_REPORT_PROP_VALUE,
	REMOVE_NEW_REPORT_IMAGE,
	SET_NEW_REPORT_ADDRESS_ATTRIBUTE,
	SET_NEW_REPORT_LOCATION,
	RESET_NEW_REPORT_FORM,
	SERVER_SEND_NEW_REPORT,
	SIGNOUT_USER,
	SHOW_NEW_REPORT_FEEDBACK,
	CREATE_NEW_REPORT_SUCCESS,
	CREATE_NEW_REPORT_ERROR,
	SET_ORGANISATION_STRUCTURE
} from 'constants/ActionTypes';

const INITIAL_STATE = {
	newReport: {
		latlng: {
			lat: null,
			lng: null
		},
		address: {
			zip: '',
			city: '',
			street: '',
			houseNumber: '',
			neighborhood: ''
		},
		typeId: 0,
		description: '',
		images: [],
		firstName: '',
		lastName: '',
		email: '',
		phone: '',
		title: '',
		responsibleId: '',
		noLocation: false,
		userComment: '',
		attachements: [],
		visible: true
	},
	showDrawer: false,
	showFeedback: false,
	loading: {
		addressToLocation: false,
		sendNewReport: false
	}
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case SIGNOUT_USER:
			return INITIAL_STATE;
		case SET_NEW_REPORT_DRAWER_STATE:
			return {
				...state,
				showDrawer: action.payload
			};
		case SET_NEW_REPORT_PROP_VALUE:
			return {
				...state,
				newReport: {
					...state.newReport,
					...action.payload
				}
			};
		case REMOVE_NEW_REPORT_IMAGE:
			return {
				...state,
				newReport: {
					...state.newReport,
					images: state.newReport.images.filter((image, index) => index !== action.payload.index)
				}
			};
		case SET_NEW_REPORT_ADDRESS_ATTRIBUTE:
			return {
				...state,
				newReport: {
					...state.newReport,
					address: { ...state.newReport.address, ...action.payload }
				},
				loading: {
					...state.loading,
					addressToLocation: false
				}
			};
		case SET_NEW_REPORT_LOCATION:
			return {
				...state,
				newReport: {
					...state.newReport,
					latlng: action.payload.latlng
				},
				loading: {
					...state.loading,
					addressToLocation: true
				}
			};
		case RESET_NEW_REPORT_FORM:
			return {
				...INITIAL_STATE,
				newReport: {
					...INITIAL_STATE.newReport,
					visible: !action.payload.reportsDefaultInvisible
				},
				showDrawer: state.showDrawer
			};
		case SERVER_SEND_NEW_REPORT:
			return {
				...state,
				showFeedback: false,
				feedBackResponsible: '',
				loading: {
					...state.loading,
					sendNewReport: true
				}
			};
		case CREATE_NEW_REPORT_ERROR:
			return { ...state, loading: { ...state.loading, sendNewReport: false } };
		case SHOW_NEW_REPORT_FEEDBACK:
			return {
				...INITIAL_STATE,
				newReport: {
					...INITIAL_STATE.newReport,
					visible: !action.payload.reportsDefaultInvisible
				},
				showFeedback: true,
				feedBackResponsible: action.payload.organisationResponsibleName || action.payload.organisationName
			};
		case SET_ORGANISATION_STRUCTURE:
			return {
				...state,
				newReport: { ...state.newReport, visible: action.payload.organisationStructure.reportsDefaultInvisible ? false : true }
			};
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./reducers/NewReport.js